import type { RouteObject } from "react-router-dom";

export type NavItem = {
  /**
   * A unique identifier for the navigation item.
   */
  value: string;
  /**
   * The display text for the navigation item.
   */
  label: string;
  /**
   * The URL to navigate to when the item is selected.
   */
  url: string;
  /**
   * Callback function invoked when the item is selected.
   */
  onSelect: () => void;
  /**
   * Optional array of child navigation items for nested menus.
   */
  children?: NavItem[];
};

type NavItemsResult = {
  /**
   * The label for the group of navigation items.
   */
  groupLabel?: string;
  /**
   * The navigation items within the group.
   */
  items: NavItem[];
};

export function buildNavItems(
  route: RouteObject,
  base = "",
  navigate: (path: string) => void
): NavItemsResult {
  const items = (route.children ?? [])
    .filter((r) => !r.index) // skip index routes
    .map((r) => {
      const fullPath = `${base}/${r.path}`;
      const label = r.handle?.label ?? "";

      return {
        value: r.path ?? "index",
        label,
        onSelect: () => navigate(fullPath),
        url: fullPath,
        children: buildNavItems(r, fullPath, navigate).items
      };
    });

  return {
    groupLabel: route.handle?.label,
    items
  };
}
